import api from "Services/API";
import {
    CreatePaymentBody,
    Params,
    financialParams,
    paymentBody,
    paymentParams,
} from "./reporting.props";
import { GetDiscountItem } from "models/Report";

//TODO define type for all the return values

export const uploadFile = (data: FormData) => {
    return api.post("/webhook/zip", data);
};

export const getFinancialPeriods = () => {
    return api.get("/admin/financial-period?trashed=1");
};

export const getFinancialPayments = ({
    periodID,
    vendorID,
}: financialParams) => {
    return api.get(`/admin/financial-period/payment/${periodID}/${vendorID}`);
};
export const getDiscountDetail = ({
    periodID,
    vendorID,
    params,
}: financialParams & Params) => {
    return api.get(
        `admin/financial-period-discount?period_id=${periodID}&vendor_id=${vendorID}`,
        { params }
    );
};
export const getSaleDetail = ({ periodID, vendorID }: financialParams) => {
    return api.get(`/admin/financial-period/amount/${periodID}/${vendorID}`);
};

export const getDemandDetail = ({ periodID, vendorID }: financialParams) => {
    return api.get(`/admin/financial-period/demand/${periodID}/${vendorID}`);
};
export const getSummary = ({ periodID, vendorID }: financialParams) => {
    return api.get(`/admin/financial-period/summary/${periodID}/${vendorID}`);
};
export const uploadPayment = (req: paymentParams) => {
    return api.post(
        `/admin/financial-period/payment-upload/${req.paymentID}`,
        req.data
    );
};

export const updatePayment = (body: paymentBody) => {
    return api.put(`/admin/financial-period/payment`, body);
};

export const updateDiscount = (body: GetDiscountItem[]) => {
    return api.put(`/admin/financial-period-discount`, body);
};
export const createPayment = (body: CreatePaymentBody) => {
    return api.post("/admin/financial-period/payment", body);
};

export const financialSaleExcel = ({ periodID, vendorID }: financialParams) => {
    return api.get(
        `/admin/financial-period/amount-excel/${periodID}/${vendorID}`
    );
};
export const financialPaymentExcel = ({
    periodID,
    vendorID,
}: financialParams) => {
    return api.get(
        `/admin/financial-period/payment-excel/${periodID}/${vendorID}`
    );
};
export const financialDiscountExcel = ({
    periodID,
    vendorID,
}: financialParams) => {
    return api.get(
        `/admin/financial-period/discount-excel?period_id=${periodID}&vendor_id=${vendorID}&trashed=1&page_size=1000`
    );
};
export const financialDemanExcel = ({
    periodID,
    vendorID,
}: financialParams) => {
    return api.get(
        `/admin/financial-period/download/demand-excel/${periodID}/${vendorID}`
    );
};
